<template>
  <div v-if="facetCounts && facetCounts.length" class="facet-card-container">
    <facet-count-card
      v-for="facetItem in facetCounts"
      :key="'facet-type-' + facetItem.facetName + '-' + facetItem.value"
      :facet-name="facetItem.facetName"
      :value="facetItem.value"
      :label="facetItem.label"
      :count="facetItem.count"
      @click="handleFacetClick"
    />
  </div>
</template>

<script>
  import TranslationsMixin from '../../util/TranslationsMixin'
  import FiltersMixin from '../../util/FiltersMixin'
  import { toAmount } from '../../util/currency'
  import { defineComponent } from 'vue'
  import FacetCountCard from '../../components/Dashboard/FacetCountCard.vue'

  export default defineComponent({
    name: 'FacetCardContainer',
    components: {
      FacetCountCard
    },
    emits: ['click'],
    props: {
      source: {
        type: String,
        default: 'home',
      },
      facetCounts: {
        type: Array,
        default: () => [],
      },
      spottingAreaId: {
        type: Number,
        default: null,
      },
    },
    methods: {
      toAmount,
      handleFacetClick(facet) {
        this.$emit('click', facet)
      },
    },
    computed: {
      config () {
        return this.$store.state.config
      },
      availableFilterControls () {
        return this.config.simplifiedFilterControls || []
      },
    },
    mixins: [TranslationsMixin, FiltersMixin],
  })
</script>

<style scoped lang="scss">
  @import "../../../scss/variables.scss";

  .facet-card-container {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: 100%;
    gap: 1%;

    @media screen and (max-width: $screen-lg) {
      gap: 2%;
      .facet-count-card {
        flex-basis: calc(100% / 3 - 2%);
      }
    }

    @media screen and (max-width: $screen-md) {
      gap: 3%;
      .facet-count-card {
        flex-basis: calc(100% / 2 - 3%);
      }
    }
  }

  .category-stats__child:hover {
    background-color: #f7f7f7;
    border: 1px solid #f7f7f7;
  }

</style>
